/**
 * Tradução de erros crus da Evolution API pra mensagens em pt-BR que fazem
 * sentido pro usuário final (issue #82) — em vez de vazar texto técnico tipo
 * "POST /instance/logout/deebs-1 -> 500: ...".
 */
const PATTERNS = [
  {
    re: /timeout|timed out/i,
    text: 'O servidor do WhatsApp demorou demais pra responder. Tente novamente em instantes.',
  },
  {
    re: /50[0-9]|ECONNREFUSED|ECONNRESET|fora do ar/i,
    text: 'Não foi possível falar com o servidor do WhatsApp agora. Tente novamente em alguns minutos.',
  },
  {
    re: /não configurado|nao configurado|not configured/i,
    text: 'A integração do WhatsApp não está configurada. Fale com o suporte.',
  },
  {
    re: /404|not found|não encontrad/i,
    text: 'Instância não encontrada. Feche e abra a conexão de novo.',
  },
  {
    re: /already in use|403/i,
    text: 'A conexão já existe mas está temporariamente indisponível no servidor do WhatsApp. Feche e abra de novo em instantes.',
  },
]

export function friendlyWaError(raw) {
  const fallback = 'Não foi possível conectar ao WhatsApp agora. Tente novamente em alguns minutos.'
  if (!raw) return fallback
  const hit = PATTERNS.find((p) => p.re.test(raw))
  return hit ? hit.text : fallback
}

/** Aviso de bloqueio temporário: o próprio WhatsApp (não a Evolution) pode
 * recusar novos pareamentos depois de várias tentativas seguidas na mesma
 * conta — não dá pra detectar isso via API, só orientar quando o padrão de
 * uso sugere que pode estar acontecendo. */
export const WA_TEMP_BLOCK_HINT =
  'Você tentou conectar várias vezes seguidas. Depois de muitas tentativas o próprio ' +
  'WhatsApp pode bloquear temporariamente novos pareamentos ("tente novamente mais tarde") ' +
  '— se isso aparecer no celular, aguarde alguns minutos antes de tentar de novo.'
